module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style7/accordian-style7.component.scss
// module id = ./src/app/features/accordian/accordian-style7/accordian-style7.component.scss
// module chunks = main